import { useState } from 'react';
import { followUser, unfollowUser, cancelFollowRequest } from '../api/userFollowApi';

export const useFollow = () => {
  const [loadingId, setLoadingId] = useState(null);

  const toggleFollow = async (targetUserId, currentlyFollowing, requestSent, onSuccess, onError) => {
    setLoadingId(targetUserId);

    try {
      if (currentlyFollowing) {
        // Optimistic update
        onSuccess({ isFollowing: false, requestSent: false });
        await unfollowUser(targetUserId);

      } else if (requestSent) {
        // Optimistic update
        onSuccess({ isFollowing: false, requestSent: false });
        await cancelFollowRequest(targetUserId);

      } else {
        const result = await followUser(targetUserId);
        if (result?.status === 'REQUESTED') {
          onSuccess({ isFollowing: false, requestSent: true });
        } else {
          onSuccess({ isFollowing: true, requestSent: false });
        }
      }
    } catch (error) {
      // Rollback to original state
      onError({ isFollowing: currentlyFollowing, requestSent });
      console.error('Follow toggle failed:', error);
    } finally {
      setLoadingId(null);
    }
  };

  return { toggleFollow, loadingId };
};